<i18n src='../common_locales.yaml'></i18n>

<i18n>
en:
  home: "Restaurants"
  enter_address: "Enter your location"
  set_address: "Set location"
  change_address: "Change"
  self_pickup: "Self Pick Up"
ja:
  home: "店舗一覧"
  enter_address: "住所を指定"
  set_address: "設定"
  change_address: "編集"
  self_pickup: "ピックアップ"
</i18n>

<template lang="pug">
.app-nav
  nav.navbar.navbar-expand.navbar-dark.fixed-top.theme-bg-primary
    router-link(@click.native="closeMenu()", to="/" active-class="active" exact)
      img.logo(src="../assets/logo.svg")
    ul.navbar-nav.ml-auto
      li.nav-item(v-if="loggedIn === false")
        a.nav-link.hideOnMobile(@click="pushRegister") {{ $t('register') }}
      li.nav-item(v-if="loggedIn === false")
        a.nav-link.hideOnMobile(@click="pushLogin") {{ $t('log_in') }}
        .nav-link.dropdown-toggle.onlyOnMobile(id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="$modal.close()")
          img.img-avatar.navbar-avatar(src="../assets/avatar_placeholder.png")
        .dropdown-menu.dropdown-menu-right
          a.dropdown-item(@click="pushLogin") {{ $t('log_in') }}
          a.dropdown-item(@click="pushRegister") {{ $t('register') }}
      li.nav-item.dropdown(v-if="loggedIn === true")
        .nav-link.dropdown-toggle(id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="$modal.close()")
          img.img-avatar.navbar-avatar(v-if="user.profile.profile_picture" :src="user.profile.profile_picture_ssl")
          img.img-avatar.navbar-avatar(v-else src="../assets/avatar_placeholder.png")
          span.ml-1.d-none.d-md-inline-block {{ user.profile.display_name | truncate(15) }}
        .dropdown-menu.dropdown-menu-right
          a.dropdown-item(@click="pushToMyOrder") {{ $t('my_order') }}
          a.dropdown-item(@click="pushToProfile") {{ $t('profile') }}
          a.dropdown-item(@click="pushLogout") {{ $t('logout') }}
      li.nav-item.dropdown(@click="clickCartDropdown")
        .nav-link.nav-cart
          img.icon-cart(src="../assets/ic_cart.svg")
          span.ml-2.badge.badge-pill.badge-danger(v-show="cartItems.length > 0") {{ cartItemsCount }}
        modal-view(name="nav-dropdown")
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import CartDropdown from './CartDropdown.vue'
import api from '../api'

export default {
  components: {
    CartDropdown
  },
  computed: {
    ...mapState({
      userLocation: state => state.cart.userLocation,
      deliveryType: state => state.cart.deliveryType
    }),
    ...mapGetters({
      loggedIn: 'isLoggedIn',
      user: 'getUser',
      cartItems: 'getCartItems'
    }),
    cartItemsCount () {
      return this.cartItems.reduce((count, item) => {
        count += item.quantity
        return count
      }, 0)
    }
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    closeMenu () {
      $('#navbarNavDropdown').collapse('hide')
    },
    pushToMyOrder () {
      this.closeMenu()
      this.$router.push('/orders')
    },
    pushToProfile () {
      this.closeMenu()
      this.$router.push('/profile')
    },
    pushRegister () {
      this.closeMenu()
      this.$router.push('/register')
    },
    pushLogin () {
      this.closeMenu()
      this.$modal.open('login')
    },
    pushLogout () {
      this.destroyToken()
      this.closeMenu()
      this.$router.push('/')
      this.logout()
    },
    destroyToken () {
      api.post('/customers/logout/').then(response => {
        console.log('logout')
      })
      .catch(error => {
        console.log(error)
      })
    },
    clickCartDropdown (e) {
      e.preventDefault()
      this.$modal.open('cart-dropdown')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-nav {
  .dropdown-toggle::after {
    display: none;
  }
}
.navbar {
  justify-content: start;
  padding: 8px;
}
.logo {
  padding-left: 8px;
}
.dropdown-toggle {
  padding-top: 0;
  padding-bottom: 0;
  background: 0;
  border: 0;
}
.dropdown-toggle::after {
  margin-left: 0.5em;
  vertical-align: 0.1em;
}
.icon-cart {
  opacity: 0.5;
}
.icon-location {
  margin-right: .5rem;
  margin-top: -.25rem;
}
.nav-cart {
  cursor: pointer;
}
.nav-cart:hover {
  .icon-cart {
    opacity: 0.75;
  }
}
.active .icon-cart {
  opacity: 0.9;
}
@media(max-width: 767px) {
  .app-nav {
    .img-avatar {
      width: 30px;
      height: 30px;
      margin-top: 6px;
    }
  }
}

.location-bar {
  background: #01A04B;
  color: #fff;
  padding: 10px;
  display: flex;
  align-items: center;

  .location-text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 5px;
    opacity: 0.7;
  }
}

// Hide On Mobile //
.hideOnMobile {
  @media (max-width:575px) {
    display: none;
  }
}
.onlyOnMobile {
  @media (min-width:575px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppNav.vue